
import { createContext, useReducer } from "react";
import AgenceReducer from "./AgenceReducer";

const INITIAL_STATE = {
    agences: [],
    count: 1,
    isFetching: false,
    error: false,
    agence: {},
    isFetchingAdd: false,
    errorAdd: false,
    isFetchingUpdate: false,
    errorUpdate: false,
    agencesByWilaya: [],
};


export const AgenceContext = createContext(INITIAL_STATE);

export const AgenceContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(AgenceReducer, INITIAL_STATE);
    
    return (
      <AgenceContext.Provider
        value={{
          agences: state.agences,
          count: state.count,
          isFetching: state.isFetching,
          error: state.error,
          agence: state.agence,
          isFetchingAdd: state.isFetchingAdd,
          errorAdd: state.errorAdd,
          isFetchingUpdate: state.isFetchingUpdate,
          errorUpdate: state.errorUpdate,
          agencesByWilaya: state.agencesByWilaya,
          dispatch,
        }}
      >
        {children}
      </AgenceContext.Provider>
    );
  };